import Model from 'flarum/common/Model';
import { tt } from '../i18n';

export default class Club extends Model {
  slug = Model.attribute('slug');
  name = Model.attribute('name');
  aliases = Model.attribute('aliases');
  type = Model.attribute('type');
  city = Model.attribute('city');
  municipality = Model.attribute('municipality');
  province = Model.attribute('province');
  country = Model.attribute('country');
  address = Model.attribute('address');
  lat = Model.attribute('lat');
  lng = Model.attribute('lng');
  opened = Model.attribute('opened');
  closed = Model.attribute('closed');
  yearsNote = Model.attribute('yearsNote');
  genres = Model.attribute('genres');
  knownFor = Model.attribute('knownFor');
  description = Model.attribute('description');
  historyHtml = Model.attribute('historyHtml');
  historySource = Model.attribute('historySource');
  sources = Model.attribute('sources');
  tracks = Model.attribute('tracks');
  timeline = Model.attribute('timeline');
  people = Model.attribute('people');
  media = Model.attribute('media');
  sites = Model.attribute('sites');
  places = Model.attribute('places');
  videos = Model.attribute('videos');
  livesets = Model.attribute('livesets');
  confidence = Model.attribute('confidence');
  isVerified = Model.attribute('isVerified');
  isFeatured = Model.attribute('isFeatured');
  discussionCount = Model.attribute('discussionCount');
  postCount = Model.attribute('postCount');
  translation = Model.attribute('translation');
  tag = Model.hasOne('tag');

  /** "1985–1997", "vanaf 1990" (fr: "depuis 1990"), … of '' als niets bekend is. */
  years() {
    const o = this.opened();
    const c = this.closed();
    if (o && c) return o === c ? String(o) : `${o}–${c}`;
    if (o) return tt('common.years_from', { year: o });
    if (c) return tt('common.years_until', { year: c });
    return '';
  }

  /** Decennia waarin de club (vermoedelijk) open was, bv. [1980, 1990]. */
  decades() {
    const o = this.opened();
    const c = this.closed() || o;
    if (!o) return [];
    const out = [];
    for (let d = Math.floor(o / 10) * 10; d <= Math.floor(c / 10) * 10; d += 10) out.push(d);
    return out;
  }

  isAbroad() {
    return (this.country() || 'BE') !== 'BE';
  }

  searchText() {
    return [this.name(), ...(this.aliases() || []), this.city(), this.municipality(), this.province()]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
  }
}
